import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Badge
} from 'reactstrap';
import moment from 'moment';
import $ from 'jquery';
import AppPage from '../../views/AppPage/'

class Pages extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			stdcat : '',
			_message : '',
			alertClass :'',
			posts : [],
			_redirect : false,
			addDirect : false,
		}
		this.onChange = this.onChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	onBack(e){
		
		this.setState({addDirect :true});
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onUpdate(id){
		
		this.state.idd = id;
		this.setState({_redirect : true});
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) {
				$("#showLoader").show();
			PostData('page/deletepage',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Page Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	componentWillMount() {
		 
		this.getdata();
	}
	
	getdata(){
		$("#showLoader").show();
		GetData('page/getpage').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	checkdate(dat){
		
		var ed = new Date(dat);
		var momentObj = moment(ed);
		var momentString = momentObj.format('MMMM DD , Y');
		return momentString;
	}
	
	checkapp(isapp){
		
		var app = [];
		if(isapp == 1){
			
			app.push(<Badge className="mr-1" color="success">Yes</Badge>)
		}
		else{
			
			app.push(<Badge className="mr-1" color="danger">No</Badge>)
		}
		return app;
	}
	
  render() {
	
	if(this.state._redirect){
		  
		return (<Redirect to={'/page/editpage/' + this.state.idd} />);

	}
	
	if(this.state.addDirect){
		  
		return (<Redirect to={'/page/addpage'} />);

	}
	
    return (
		<div>
		  <AppPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="12">
				   <Card>
					<CardHeader>
						<strong>Pages</strong>
						<Button outline color="primary" className="btn-right" onClick={this.onBack}>Add Page</Button>
					</CardHeader>
					<CardBody>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Page Title</th>
								<th>For App show / Order</th>
								<th width="100">Manage</th>
							</tr>
						</thead>
						<tbody>
						  {this.state.posts.map((item,index) =>
							<tr key = {item}>
								<td>{index+1}</td>
								<td>{item.title}<br></br><span className="text-primary">{this.checkdate(item.idate)}</span></td>
								<td>{this.checkapp(item.isapp)} / {item.orderno}</td>
								<td>
									<button name="edit" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>&nbsp;&nbsp;
									<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
								</td>
							</tr>
						  )}
						</tbody>
					</Table>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Pages;


// WEBPACK FOOTER //
// ./src/page/Pages/Pages.js